/*
Scroll reveal: page blocks fade and rise in once as they enter the viewport.
Content is only hidden once this script runs (html.has-reveal), so no JS or
reduced motion means everything stays visible.
*/

const blocks = document.querySelectorAll("#site-main > .block-spacer");
const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

if (blocks.length && !reduced && "IntersectionObserver" in window) {
  // Blocks already on screen at load show at once: no flash, no LCP delay.
  blocks.forEach((block) => {
    if (block.getBoundingClientRect().top < window.innerHeight) {
      block.classList.add("is-inview");
    }
  });

  document.documentElement.classList.add("has-reveal");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-inview");
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: "0px 0px -10% 0px", threshold: 0.1 }
  );

  blocks.forEach((block) => {
    if (!block.classList.contains("is-inview")) observer.observe(block);
  });
}
